

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

define(function (require, exports, module) {

    /**
     * @file 类属性相关的扩展
     * @author 子虔
     * @date    2014-08-18 17:41:24
     */

    var parseParam = require('./parse-param'),
        isEqual = require('./is-equal');

    module.exports = {
        /**
         * 设置参数，可通过`a/b/c/d`的方式设置
         * @param {*} name - 名称或对象
         * @param {*} [value] - 属性值
         * @param {boolean} [silent=false] - 设置的值变化时，是否派发事件
         */
        set: function set(name, value, silent) {
            var data,
                names,
                lastValue,
                len,
                that = this;

            if (typeof name == 'string') {
                names = name.split('/');
                len = names.length;
                if (len > 1) {
                    names.forEach(function (item, index) {
                        if (index == len - 1) {
                            lastValue = data[item];
                            data[item] = value;
                            if (!silent && !isEqual(lastValue, value)) {
                                bubbling.call(that, names, value, lastValue);
                            }
                        } else {
                            data = data || that.attributes;
                            data[item] = data[item] || {};
                            data = data[item];
                        }
                    });
                    return;
                }
            }

            function bubbling(names, value, lastValue) {
                var name = names.length == 1 ? names[0] : names.join('/');

                if (names.length > 0) {
                    this.emit('change:' + name, value, lastValue);
                    names.pop();
                    bubbling.call(this, names, value, lastValue);
                }
            }

            return this.Parent(set, arguments);
        },
        /**
         * 获取参数,可通过`a/b/c/d`获取如上`set`例子中的`d`值
         * @param {string} name - 名称
         * @return {*}
         */
        get: function get(name) {
            var that = this,
                names,
                value = '',
                data,
                len;

            if (typeof name == 'string') {
                names = name.split('/');
                len = names.length;

                if (len > 1) {
                    names.forEach(function (item, index) {
                        if (index == len - 1 && data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) == 'object') {
                            value = data[item];
                        } else {
                            data = data || that.attributes;
                            data[item] = data[item];
                            data = data[item];
                        }
                    });

                    return value;
                }
            }

            return this.Parent(get, arguments);
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-base/dist/attributes.js
// module id = 44
// module chunks = 0